import * as ThingsApi from './things';
import AuthUsersApiService from './auth-users';
import NotesApiService from './notes';
import LabelsApiService from './labels';
import AlertsApiService from './alerts';
import NotificationsApiService from './notifications';
import EventsApiService from './events';
import HistoryApiService from './history';
import ConfigApiService from './config';
import FoldersApiService from './folders';
import ViewsApiService from './views';
import NavigationApiService from './navigation';
import CategoriesApiService from './categories';
import MenuApiService from './menu';
import DeveloperApiService from './developer';
import AlertsActionsApiService from './alerts-actions';
import CustomersApiService from './customers';
import RolesApiService from './roles';
import UsersApiService from './users';
import PrivilegesApiService from './privileges';
import FeedbackApiService from './feedback';

export {
    ThingsApi,
    AuthUsersApiService,
    NotesApiService,
    LabelsApiService,
    AlertsApiService,
    NotificationsApiService,
    EventsApiService,
    HistoryApiService,
    ConfigApiService,
    FoldersApiService,
    ViewsApiService,
    NavigationApiService,
    CategoriesApiService,
    MenuApiService,
    DeveloperApiService,
    AlertsActionsApiService,
    CustomersApiService,
    RolesApiService,
    UsersApiService,
    PrivilegesApiService,
    FeedbackApiService
};



// WEBPACK FOOTER //
// ./app/services/api/index.js